// @flow
import * as React from 'react';
import { rankWith, uiTypeIs } from '@jsonforms/core';
import useControlProps from '../../util/useControlProps';
import SlotManagementUI from './SlotManagementUI';

type Props = {};

const SlotManagementControl = (props: Props): React.Node => {
    const {
        data: rescheduleConfig,
        path,
        handleChange,
        label
    } = useControlProps(props);
    const translationPath = `settings.trackIQ.fields.taskSettings.fields.rescheduleConfig`;

    return (
        <SlotManagementUI
            value={rescheduleConfig}
            onChange={value => handleChange(path, value)}
            translationPath={translationPath}
            label={label}
        />
    );
};

export default SlotManagementControl;

export const slotManagementControlTester: any = rankWith(
    1,
    uiTypeIs('SlotManagementControl')
);
